import React, { Component } from 'react';
import PropTypes from 'prop-types';


import AccessContext from './Context';
import PermissionService from 'services/permission.service';


const permissionService = new PermissionService();

class AccessProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permissions: permissionService.permissions,
            features: [],
            resources: []
        };
    }

    render() {
        const { permissions } = this.state;
        const { children } = this.props;
        return <AccessContext.Provider value={permissions}>{children}</AccessContext.Provider>;
    }
}

AccessProvider.propTypes = {
    children: PropTypes.node
};
export default AccessProvider;
